import { Box, Grid } from '@mui/material';

import useScreen from 'hooks/useScreen';

import GamesGroup from './Group';

const GamesSection = () => {
  const { isMobile } = useScreen();

  return (
    <Box mx={isMobile && -3} mt={isMobile ? 2 : 3}>
      <Grid container spacing={isMobile ? 2 : 3}>
        <Grid item xs={12} md={6}>
          <GamesGroup title="live_games" categoryId={2} />
        </Grid>
        <Grid item xs={12} md={6}>
          <GamesGroup title="casino_games" categoryId={1} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default GamesSection;
